import qs from 'qs';
import { get } from 'object-path';

export const getQueryParameter = (parameter: string): string => {
  const search: string = window?.location?.search;
  const parsedSearch = qs.parse(get(search.split('?'), '1', ''));

  return get(parsedSearch, parameter, '');
};
